import { z } from 'zod';
import { objectId, FieldMetadata } from './base';

/**
 * AuditLog Schema
 * Represents an audit log entry for tracking API mutations
 */
export const AuditLogSchema = z.object({
  _id: objectId,
  userId: z.string(),
  email: z.string().optional(),
  sessionId: z.string().optional(),
  method: z.enum(['POST', 'PUT', 'PATCH', 'DELETE']),
  url: z.string(),
  originalUrl: z.string(),
  ip: z.string().optional(),
  userAgent: z.string().optional(),
  requestBody: z.any().optional(),
  requestParams: z.any().optional(),
  requestQuery: z.any().optional(),
  responseStatus: z.number().optional(),
  responseBody: z.any().optional(),
  leagueId: z.string().optional(),
  organizationId: z.string().optional(),
  metadata: z.any().optional(),
  createdAt: z.coerce.date().default(() => new Date()),
});

export type AuditLog = z.infer<typeof AuditLogSchema>;

export const auditLogMetadata: Record<string, FieldMetadata> = {
  _id: { hidden: true },
  userId: { label: 'User ID' },
  email: { label: 'Email' },
  sessionId: { label: 'Session ID' },
  method: { label: 'Method' },
  url: { label: 'URL' },
  originalUrl: { label: 'Original URL' },
  ip: { label: 'IP Address' },
  userAgent: { label: 'User Agent' },
  requestBody: { label: 'Request Body' },
  requestParams: { label: 'Request Params' },
  requestQuery: { label: 'Request Query' },
  responseStatus: { label: 'Response Status' },
  responseBody: { label: 'Response Body' },
  leagueId: { label: 'League ID' },
  organizationId: { label: 'Organization ID' },
  metadata: { label: 'Metadata' },
  createdAt: { label: 'Created At' },
};
